import Vue from 'vue'
import request from '@/helpers/request'

export default {
  GET_MESSAGES: ({ commit, state }, params) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.chat.get}`,
      {
        params: params,
      },
      true,
    ).then(response => {})
  },
  STORE_MESSAGES: ({ commit, state }, params) => {
    const formData = new FormData()

    formData.append('channel', params.channel)
    formData.append('message', params.message)

    if (params.hasOwnProperty('attachments') && params.attachments !== null) {
      for (let i = 0; i < params.attachments.length; i++) {
        const file = params.attachments[i]

        formData.append(`attachments[${i}]`, file)
      }
    }

    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.chat.store}`,
      {
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
  },
  SEARCH_EMPLOYEE: ({ commit, state }, val) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.search}`,
      {
        params: {
          name: val,
        },
      },
      true,
    )
  },
}
